module.exports = __webpack_public_path__ + "img/vendor2.418f9944.webp";